import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CombinedFacettenUrlService } from '../facetten/combined-facetten-url.services';
import { UrlService } from './url.service';

// Um eine Namenskollision mit dem BildungszielService (DKZ Bildungsziele) zu vermeiden,
// nutzen wir hier das Wording "Bildungsbereich"
@Injectable({ providedIn: 'root' })
export class BildungsbereichService {
  private readonly urlService = inject(UrlService);

  public static readonly URL_PARAM = 'ziel';
  private readonly combinedFacettenUrlService = inject(CombinedFacettenUrlService);

  public bildungsbereich$: Observable<BildungsBereich> = this.urlService
    .getQueryParameterValue(BildungsbereichService.URL_PARAM)
    .pipe(
      map((value) => {
        return BildungsbereichService.isUte(value)
          ? BildungsBereich.Erwerb
          : BildungsBereich.Erweitern;
      })
    );

  public isUte$ = this.bildungsbereich$.pipe(
    map((bildungsbereich) => BildungsbereichService.isUte(bildungsbereich))
  );

  public static isUte(value?: BildungsBereich | string | null): boolean {
    return value === BildungsBereich.Erwerb;
  }

  public async setBildungsbereichAndResetFacetten(bildungsbereich: BildungsBereich): Promise<void> {
    await this.combinedFacettenUrlService.resetOptionSelections();
    this.urlService.updateUrlQueryParams({ [BildungsbereichService.URL_PARAM]: bildungsbereich });
  }
}

export enum BildungsBereich {
  Erwerb = 'erwerb',
  Erweitern = 'erweitern'
}
